<div class="w-full min-h-[50px] rounded-[8px] border-[1px] bg-white mb-4 flex flex-wrap gap-2 p-2 justify-between items-center"
    [ngClass]="[canceled ? 'border-error' : 'border-border']">
    <div class="min-w-[40%] flex flex-row gap-2 justify-start">
        <img [src]="fileSrc" width="28px" height="28px" alt="{{ 'shared.file_icon' | transloco }}">
        <div>
            <p class="text-sm">{{ fileName }}</p>
            <p class="text-xs text-neutral-500">{{ fileSize }}</p>
        </div>
    </div>
    <div class="flex flex-col gap-1 items-center justify-center">
        <div *ngIf="currentValue < 100" class="flex items-center">
            <p class="text-xs text-neutral-500">{{ 'shared.file_upload.uploading' | transloco }}
            </p>
            <span class="ml-[4px] loading loading-dots loading-xs"></span>
        </div>
        <div *ngIf="canceled" class="flex items-center">
            <p class="text-xs text-error">{{ 'shared.file_upload.canceled' | transloco }}
            </p>
        </div>
        <div *ngIf="currentValue === 100 && !canceled" class="flex items-center">
            <p class="text-xs text-success">{{ 'shared.file_upload.successful' | transloco }}
            </p>
        </div>
    </div>
    <div class="flex min-w-[20%] gap-2 items-center justify-end">
        <button (click)="onStopClick()" *ngIf="currentValue < 100">
            <img src="assets/icons/close-circle-primary.svg" width="28px" height="28px"
                alt="{{ 'shared.cancel' | transloco }}">
        </button>
    </div>
</div>